import { render, staticRenderFns } from "./CtrlSearch.vue?vue&type=template&id=70449daa"
import script from "./CtrlSearch.vue?vue&type=script&lang=js"
export * from "./CtrlSearch.vue?vue&type=script&lang=js"
import style0 from "./CtrlSearch.vue?vue&type=style&index=0&id=70449daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports